import { without } from 'ramda';
import { FOfferType, isAvailableOfferTypeCombination } from '../../packages/JsonQuery';
import { useCallback } from 'react';
import { useFilterChangeCallback } from 'shared/hooks';
import { useSelector } from 'react-redux';
import { selectOfferTypeValue } from 'shared/selectors/filters';
import { TFilter } from 'shared/types/filters';

export const useOfferTypeChangeHandler = (filterKey?: TFilter) => {
  const selectedOfferTypes = useSelector(selectOfferTypeValue);

  const onChange = useFilterChangeCallback(filterKey);

  return useCallback(
    (newSelectedValues: FOfferType[]) => {
      const isSelectedOptionsShorter = selectedOfferTypes.length < newSelectedValues.length;
      const primaryOptions = isSelectedOptionsShorter ? selectedOfferTypes : newSelectedValues;
      const secondaryOptions = isSelectedOptionsShorter ? newSelectedValues : selectedOfferTypes;

      const newSelectedOfferType = without(primaryOptions, secondaryOptions)[0];

      const combinedOfferType = [...selectedOfferTypes, newSelectedOfferType].reduce(
        (previousValue, currentValue) => previousValue | currentValue,
        FOfferType.Unexpected,
      );

      let nextOfferTypes;

      if (selectedOfferTypes.includes(newSelectedOfferType) && selectedOfferTypes.length > 1) {
        nextOfferTypes = selectedOfferTypes.filter(offerType => offerType !== newSelectedOfferType);
      } else if (isAvailableOfferTypeCombination(combinedOfferType)) {
        nextOfferTypes = [...selectedOfferTypes, newSelectedOfferType];
      } else {
        nextOfferTypes = [newSelectedOfferType];
      }

      const nextOfferType = nextOfferTypes.reduce(
        (previousValue, currentValue) => previousValue | currentValue,
        FOfferType.Unexpected,
      );

      onChange({ action: 'setOfferType', arguments: [nextOfferType] });
    },
    [onChange, selectedOfferTypes],
  );
};
